import { Observable } from 'rxjs';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PricelistOnlineOptionsProductComponent } from './pricelist-online-options-product/pricelist-online-options-product.component';
import { CompanyEnum } from '../../models/company.model';
import { SharedDataStore } from '../../store';
import { PriceListPanelComponent } from '../price-list-panel/price-list-panel.component';
import { getConfiguration } from '@lx/shared/tokens';
import { PriceListsPopupComponent } from '../price-lists-popup/price-lists-popup.component';
import { TermsAndConditionsComponent } from '../terms-and-conditions/terms-and-conditions.component';
import { PriceListOnlineWithDisclaimers } from '../../models/pricelist-online-courses.model';
import { NotesComponent } from '../notes/notes.component';
import { Note } from '../../models/types';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-online-courses',
  imports: [
    CommonModule,
    PricelistOnlineOptionsProductComponent,
    ProgressSpinnerModule,
    PriceListPanelComponent,
    PriceListsPopupComponent,
    TermsAndConditionsComponent,
    NotesComponent,
  ],
  templateUrl: './online-courses.component.html',
  styleUrls: ['./online-courses.component.scss', './print-online-courses.component.scss'],
})
export class OnlineCoursesComponent implements OnInit {
  // Online courses are only available for KIL so the style will be the one for KIL always
  company = CompanyEnum.KIL;
  priceListShowTermsAndCondition: string | boolean = false;

  onlineCourses$: Observable<PriceListOnlineWithDisclaimers> | undefined;
  productsAvailable = false;
  privateLessonsNotes: Note[] = [];
  coursesNotes: Note[] = [];

  private readonly sharedDataStore = inject(SharedDataStore);
  private readonly configuration = getConfiguration();
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.priceListShowTermsAndCondition = this.configuration.PRICE_LIST_SHOW_JUNIOR_CAMPS || this.configuration.PRICE_LIST_SHOW_AYA;
    this.onlineCourses$ = this.sharedDataStore.onlineCourses$;
    this.sharedDataStore.onlineCourses$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((onlineCourse) => {
      this.coursesNotes = (onlineCourse?.courses?.disclaimers ?? []).map((d) => ({ text: d }));
      this.privateLessonsNotes = (onlineCourse?.privateLessons?.disclaimers ?? []).map((d) => ({ text: d }));
      this.productsAvailable = onlineCourse?.courses?.products?.length > 0 || onlineCourse?.privateLessons?.products?.length > 0;
    });
  }
}
